module.exports = __webpack_public_path__ + "img/logo_culturial.66b8b4dd.png";